//implementacion de ngxdatatable
//https://stackoverflow.com/questions/51303630/how-to-use-edit-and-delete-options-in-angular-ngx-datatables

//solucion para usar metodos de angular en html
//https://stackblitz.com/edit/angular-c6vfcq?file=src%2Fapp%2Fapp.component.html

//solución al asignar el input date 
//https://stackblitz.com/edit/angular-xuvrtq?file=src%2Fapp%2Fapp.component.ts

import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { DatatableComponent } from '@swimlane/ngx-datatable';
import { EmptyError } from 'rxjs';
import { UsuarioService } from '../../services/usuario.service';
import { Encuesta } from '../../models/encuesta';
import { TipoCliente } from '../../models/tipocliente';
import { EncuestaService } from '../../services/encuesta.service';
import { TipoClienteService } from '../../services/tipocliente.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $:any;

@Component({
    selector:'admin-encuestas',
    templateUrl:'./admin-encuesta.component.html',
    providers:[UsuarioService,EncuestaService,TipoClienteService],
    //styleUrls:['../']
})

export class AdminEncuestaComponent implements OnInit{
    @ViewChild('addForm') formValues:NgForm; //added this
    public title:string;
    public encuesta:Encuesta;
    public status:string;
    public errorTexto:string;
    fromDate;

    public tiposcliente : TipoCliente[];
    public tipocliente: TipoCliente;

    public token;

    editing = {};
    rows = [];
    columns = [];
    selected=[];
    temp = [];

    loadingIndicator:boolean = true;
    reaorderable: boolean = true;

    @ViewChild(DatatableComponent) table: DatatableComponent;

    constructor(
        private _usuarioService: UsuarioService,
        private _encuestaservice: EncuestaService,
        private _tipoclienteservice:TipoClienteService
    ){
        this.title = 'Catálogo de encuestas';
        this.token = this._usuarioService.getToken();
        this.inicializarClase();
        this.GRIDlistar();
}

/**
 * Métodos
 */

 inicializarClase(){
    this.encuesta = new Encuesta(0,"",this.tipocliente,new Date(),true,new Date(),new Date(),"",0);
    return this.encuesta;
 }
ngOnInit(){
    console.log('Componente admin-encuesta cargado');
    this.obtenerTiposCliente(this.token);
    this.token = this._usuarioService.getToken();

    this.columns = [
        { Name:'ID',prop: 'ID'},
        { name:'DESCRIPCIÓN', prop: 'DESCRIPCION'},
        { name:'TIPO CLIENTE', prop: 'TipoCliente.DESCRIPCION' },
        { name:'ESTATUS', prop:'estatus_texto'}
    ]
}

obtenerTiposCliente(token){
    this._tipoclienteservice.obtenerActivas(token).subscribe(
        response =>{
            this.tiposcliente = response.items;
        },
        err=>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error'; 
            }
        }
    )
}

btn_nuevo(){
    this.inicializarClase();
    this.selectedValue= this.tiposcliente[0];
    $('#exampleModal').modal('show');
}

selectedValue: any;
doSomething() {
    //console.log(this.selectedValue);
    this.encuesta.TipoCliente = this.selectedValue;
}// setNewUser()

GRIDlistar(){
    this._encuestaservice.GRIDlistar(this.token).subscribe(
        response =>{
            this.rows = response.items;
            this.temp = response.items;
        },
        err =>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    );
}

    /*onSelect({ selected }) {
        console.log('Select Event', selected, this.selected);
      }*/
    
    onActivate(event) {
    if(event.type == 'click') {
        this.status = "";
        this.encuesta = event.row;
        this.selectedValue = this.tiposcliente.find(x => x.ID === this.encuesta.ID_TIPO_CLIENTE);
        $('#exampleModal').modal('show');
    }
}

onSubmit(){
    this._encuestaservice.gestion(this.encuesta,this.token).subscribe(
        response =>{
            $('#txtBuscar').val('');
            this.GRIDlistar();
            this.formValues.resetForm(); // Added this
            this.status = "";
            $('#exampleModal').modal('hide');
        },
        err =>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    );
}

updateFilter(event) {
    const val = event.target.value.toLowerCase();   
    // filter our data
    const temp = this.temp.filter(function(d) {
        return d.DESCRIPCION.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
}
}